import axios from "axios";
import { toast } from "react-toastify";

const sendEmail = ({
  userEmail, // Default email
  itemName, // Default item
  subject, // Default subject
  message, // Default message
  recepient, // Optional recipient
}) => {
  // Create the payload and include recipient only if it's provided
  const payload = {
    userEmail,
    itemName,
    subject,
    message,
    recepient,
  };

  console.log("Email payload:", payload); // Add this for debugging

  console.log("EMAILUTIL DATA SENT TO USER (GENERAL), ", payload);
  // If recipient is provided, add it to the payload

  // Make the POST request
  return axios
    .post(`${process.env.REACT_APP_SERVER_URL}/purchases/send-email`, payload, {
      headers: {
        "Content-Type": "application/json", // Ensure the correct content type
      },
    })
    .then((response) => {
      if (response.status === 200) {
        console.log("Emails sent successfully:", response.data.message);
        return response;
      } else {
        console.error("Failed to send emails:", response.data.error);
        throw new Error(response.data.error);
      }
    })
    .catch((error) => {
      console.error("Error sending emails:", error);
      throw error; // Re-throw the error to be handled by the component
    });
};

export default sendEmail;
